module.exports = __webpack_public_path__ + "static/img/IMG_1809_05.dfbf6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_1809_05.png
// module id = RJlL
// module chunks = 1